export default __webpack_public_path__ + "static/media/EM1290.34I-35914_-25381_0.77e91eff.jpg";